// extracted by mini-css-extract-plugin
export default {"hideOnMobile":"HintConfirmationContent_hideOnMobile__NV5QU"};